import React, { useState, useEffect } from 'react';

const TARGET = new Date('2026-02-23T23:59:59Z');
const lexend = '"Lexend", sans-serif';

function pad(n) {
  return String(n).padStart(2, '0');
}

function getTimeLeft() {
  const now = new Date();
  const diff = Math.max(0, TARGET - now);
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const secs = Math.floor((diff % (1000 * 60)) / 1000);
  return { days, hours, mins, secs };
}

export default function CountdownTimer({ label = 'Close In', compact = false }) {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft());

  useEffect(() => {
    const t = setInterval(() => setTimeLeft(getTimeLeft()), 1000);
    return () => clearInterval(t);
  }, []);

  const { days, hours, mins, secs } = timeLeft;
  const display = `${pad(days)}d ${pad(hours)}h ${pad(mins)}m ${pad(secs)}s`;

  return (
    <div style={{
      display: 'flex',
      flexDirection: compact ? 'row' : 'column',
      alignItems: compact ? 'center' : 'flex-start',
      gap: compact ? '0.5rem' : '0.25rem'
    }}>
      {label != null && label !== '' && (
        <span style={{
          fontFamily: lexend,
          fontOpticalSizing: 'auto',
          fontSize: compact ? '0.75rem' : '0.85rem',
          fontWeight: 500,
          color: '#000',
          textTransform: 'uppercase',
          letterSpacing: '0.05em'
        }}>
          {label}
        </span>
      )}
      <span style={{
        fontFamily: lexend,
        fontOpticalSizing: 'auto',
        fontWeight: 700,
        fontSize: compact ? '1.1rem' : '1.5rem',
        fontVariantNumeric: 'tabular-nums',
        color: '#000'
      }}>
        {display}
      </span>
    </div>
  );
}
